<template>
	<article role="article" class="hhdealers__result" :class="[ isPro ? 'hhdealers__result--pro' : '' ]">
		<div class="hhdealers__result__inner">
			<div class="hhdealers__result__inner__top">
				<h3>{{ dealer.name }}</h3>
				<div class="hhdealers__result__address">
					<span class="hhdealers__result__address__streetAddress">{{ dealer.dealer_streetaddress }}</span>, 
					<span class="hhdealers__result__address__postalCode">{{ dealer.dealer_postalcode }}</span>&nbsp;
					<span class="hhdealers__result__address__addressLocality">{{ dealer.dealer_locality }}</span>
				</div>

				<div class="hhdealers__result__phone" v-if="hasPhone">
					<span class="hhdealers__result__telephone"><a :href="formattedPhone">{{ dealer.dealer_telephone }}</a></span>
				</div>

				<div class="hhdealers__result__brands">
					<ul class="hhdealers__result__brandslist">
						<li class="hhdealers__result__brandslist__item"
							:class="[ brand.pro === true ? 'hhdealers__result__brandslist__item__pro' : '' ]"
							v-for="( brand, i ) in dealer.brands" 
							:key="i">{{ brand.name }}
						</li>
					</ul>
				</div>
			</div>

			<div class="hhdealers__result__inner__bottom">
				<ul class="hhdealers__result__ctas">
					<li><a class="hhdealers__result__cta hhdealers__result__cta--contact" :href="contact">{{ this.getMicroCopy().dealer_copy_label_contact }}</a></li>
					<li><a class="hhdealers__result__cta hhdealers__result__cta--route" :href="'https://www.google.com/maps/dir/?api=1&destination=' + directions" target="_blank">{{ this.getMicroCopy().dealer_copy_label_directions }}</a></li>
					<li><a class="hhdealers__result__cta hhdealers__result__cta--show-on-map" href="#dealer-locator-map" @click.prevent="handleOpenMarker">{{ this.getMicroCopy().dealer_copy_label_show_on_map }}</a></li>
				</ul>

				<aside v-if="isPro" class="hhdealers__result__pro">
					<div class="hhdealers__result__pro__label">PRO <i class="fa fa-star" aria-hidden="true"></i></div>
					<span v-for="brand in proBrands" :key="brand.ID" class="hhdealers__result__pro__brand">{{ brand.name }}</span>
				</aside>
			</div>

		</div>
	</article>	
</template>
<script>
import { mapGetters } from 'vuex'
import eventbus from '../utils/eventbus'
export default {
	props: ['dealer'],
	methods: {
		...mapGetters([
			'getActiveFilter',
			'getDealersMapSettings',
			'getMicroCopy',
			'getReferrerProduct',
			'getReferrerProductID'
		]),
		handleOpenMarker () {
			eventbus.$emit( 'open-marker', {
				lat: this.dealer.latlong.dealer_lat,
				lng: this.dealer.latlong.dealer_long
			} )
			const mapEl = document.getElementById( "dealer-locator-map" )
			window.scrollTo({
				top: mapEl.getBoundingClientRect().top,
				behavior: 'smooth'
			});
		}
	},
	computed: {
		directions () {
			return encodeURIComponent( 
				`${ this.dealer.dealer_streetaddress },${this.dealer.dealer_postalcode} ${ this.dealer.dealer_locality }`
			)
		},

		hasPhone() {
			return this.dealer.dealer_telephone !== "undefined"
		},

		formattedPhone() {
			let phone = this.dealer.dealer_telephone
			if ( ! phone ) {
				return ''
			}
			let formattedPhone = phone.replace( /[.\-+ /]/g, '' )
			if ( formattedPhone.match( /^00.*/ ) !== null ) {
				return `tel:+${ formattedPhone }`
			} else {
				if ( this.getDealersMapSettings() && this.getDealersMapSettings().country_code === 'nl' ) {
					return `tel:${ formattedPhone.replace( /^0(.*)/, `+31$1` ) }`
				} else {
					return `tel:${ formattedPhone.replace( /^0(.*)/, `+32$1` ) }`
				}
			}
		},

		contact () {
			const baseURL = this.getDealersMapSettings().contact_page_url
			const prettyBrandName = this.dealer.brands.find( ( brand ) => {
				return brand.slug === this.getActiveFilter()
			} ).name

			let infoFormVars =  {
				info_brand : encodeURIComponent( prettyBrandName ),
				dealer_info : encodeURIComponent( `${ this.dealer.name }, ${ this.dealer.dealer_streetaddress }, ${ this.dealer.dealer_postalcode } ${ this.dealer.dealer_locality }` ),
				dealer_email : encodeURIComponent( this.dealer.dealer_email )
			}
			if ( this.getReferrerProduct !== '' ) {
				infoFormVars.info_product = encodeURIComponent( this.getReferrerProduct() )
			}
			if ( this.getReferrerProductID !== '' ) {
				infoFormVars.url_product = this.getReferrerProductID()
			}

			let infoFormQueryString = baseURL + '?'
			for ( const [key, value] of Object.entries( infoFormVars ) ) {
				infoFormQueryString += `${ key }=${ value }&`
			}
			return infoFormQueryString.slice( 0, infoFormQueryString.length - 1 )
		},

		isPro () {
			return this.dealer.brands.filter( ( brand ) => brand.pro === true ).length > 0
		},

		proBrands () {
			return this.dealer.brands.filter( ( brand ) => brand.pro === true )
		}
	}
}
</script>